<template>
    <main role="main" class="container">
        <div class="row">
            <div class="col-md-12">
                <h3 class="pb-4 mb-4 border-bottom">
                    Новости
                </h3>
            </div>

            <aside class="col-md-4">
                <div class="p-4 mb-3 bg-light rounded">
                    <ol class="list-unstyled mb-0">
                        <li v-for="news in newsList" v-bind:key="news.id">
                            <a :href="'#news' + news.id">
                                {{news.title}}<br/>
                                {{news.date}}
                            </a>
                        </li>
                    </ol>
                </div>
            </aside>

            <div class="col-md-8 news-main">
                <div v-for="news in newsList" v-bind:key="news.id" class="news-post" :id="'news' + news.id">
                    <h2 class="news-post-title">{{news.title}}</h2>
                    <p class="news-post-meta">{{news.date}}</p>
                    <div v-html="news.text"></div>
                    <div class="text-center mb-3" v-if="news.imageLink != 0">
                        <img :src="'https://sale.katris.ru/uploads/images/saleKatrisNews/' + news.imageLink" style="max-width: 100%" />
                    </div>
                </div>

                <nav class="news-pagination">
                    <a class="btn btn-outline-primary mr-2" href="#" @click="older()"><i class="las la-angle-left"></i> Назад</a>
                    <a v-if="pagination == 0" class="btn btn-outline-secondary disabled" disabled href="javascript:">Вперед <i class="las la-angle-right"></i></a>
                    <a v-else class="btn btn-outline-primary" href="#" @click="newer()">Вперед <i class="las la-angle-right"></i></a>
                </nav>
            </div>
        </div>

        <modal name="lastNews" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               width="60%"
               height="auto" @closed="closeNewNews()">
            <div v-if="modalNews" style="padding: 20px; text-align: center">
                <h2 class="news-post-title">{{modalNews.title}}</h2>
                <p class="news-post-meta">{{modalNews.date}}</p>

                <div>
                    <div v-html="modalNews.text"></div>
                    <div class="text-center mb-3" v-if="modalNews.imageLink != 0">
                        <img :src="'https://sale.katris.ru/uploads/images/saleKatrisNews/' + modalNews.imageLink" style="max-width: 100%" />
                    </div>
                </div>

                <div class="row justify-content-center">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block" @click="$modal.hide('lastNews')">Закрыть</button>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="expired" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               width="60%"
               height="auto">
            <div style="padding: 20px; text-align: center">
                <div class="row">
                    <div class="col-md-2">
                        <img src="@/assets/img/warning.png" style="width: 100%; padding: 0px 16px;" alt="" />
                    </div>
                    <div style="font-size: 14px" class="col-md-10">
                        <p style="font-size: 16px; font-weight: bold">Ваш личный кабинет в SALE.KATRIS.RU подлежит блокировке при отсутствии заказов</p>

                        В связи с отсутствием отгруженных заказов, оформленных через интеллектуальную систему SALE.KATRIS.RU, Ваш личный кабинет подлежит блокировке через <span v-if="expirationStatus == 0">2 месяца</span><span v-else>14 дней</span>.<br/>
                        Для предотвращения блокировки оформите заказ.<br/>
                        Заказ должен быть отгружен.
                    </div>
                </div>

                <div class="row justify-content-center mt-4">
                    <div class="col-md-4">
                        <button class="btn btn-outline-primary btn-block" @click="$modal.hide('expired')">Закрыть</button>
                    </div>
                </div>
            </div>
        </modal>

        <modal name="toOrder" :min-width="200"
               :min-height="200"
               :adaptive="true"
               :scrollable="true"
               :reset="true"
               :backdrop="false"
               width="600px"
               height="auto">
            <div style="padding: 20px">
                <div class="row">
                    <div class="col-md-12">
                        <h2 class="text-center">На складе закончились товары:</h2>
                        <table class="table">
                            <thead>
                            <tr>
                                <td>Наименование</td>
                                <td>Материал</td>
                                <td>Ширина</td>
                                <td>Высота</td>
                                <td>Количество к заказу</td>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="item in toOrder" v-bind:key="item.id">
                                <td>{{item.type}} {{item.name}}</td>
                                <td>{{item.material}}</td>
                                <td>{{item.width}}</td>
                                <td>{{item.height}}</td>
                                <td>{{item.toOrder}}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <a href="/readyMade" class="btn btn-primary btn-block">Перейти в RM</a>
                        <input type="button" class="btn btn-primary btn-block" value="Закрыть" @click="$modal.hide('toOrder')" />
                    </div>
                </div>
            </div>
        </modal>
    </main>
</template>

<script>
    import rm_katris from "../js/rm_katris/app";

    const newsPerPage = 3;

    export default {
        name: "News",
        metaInfo: {
            title: 'Новости',
            titleTemplate: '%s - sale.katris'
        },
        data() {
            return {
                newsList: [],
                pagination: 0,
                modalNews: {},
                expirationStatus: 0,
                toOrder: []
            };
        },
        created() {
            rm_katris.params.url = 'https://sale.katris.ru/proxy/';
            rm_katris.params.session = this.$session.get('user');
            rm_katris.user = this.$session.get('user');

            this.getNewsList();

            this.checkRMStorage();
        },
        methods: {
            getNewsList: function() {
                let self = this;
                self.newsList = [];
                // rm_katris.params.url = 'https://sale.katris.ru/proxy/AI_HELPER_45745673029734/'; //debug ONLY
                rm_katris.makePost('katrisSaleAdmin', 'getActiveNewsList', {'token': this.$session.get('jwt'), 'pagination': this.pagination}, null, function(response) {
                    if (response.status === 'OK') {
                        for (let key in response.data) {
                            response.data[key].text = response.data[key].text.replace('img src="/', 'img src="https://sale.katris.ru/');

                            let date =  new Date(response.data[key].date * 1000);
                            let month = date.getMonth() + 1;
                            let minutes = date.getMinutes();
                            if (minutes < 10) {
                                minutes = '0' + Number(minutes);
                            }
                            response.data[key].date = date.getDate() + '.' + (month < 10 ? '0' : '') + month + '.' + date.getFullYear() + ' ' + date.getHours() + ':' + minutes;

                            self.newsList.push(response.data[key]);
                        }

                        if (self.$session.get('user').katrisUser != 1 && (self.$session.get('user').exStatus == 2 || self.$session.get('user').exStatus == 3)) {
                            if (self.$session.get('user').exStatus == 3) self.expirationStatus = 1;
                            self.$modal.show('expired')
                        }
                    }
                });

                let session = self.$session.get('user');

                if (session.newNews == 1 && !this.isMobile()) {
                    rm_katris.makePost('katrisService', 'getActiveModalNews', {'token': this.$session.get('jwt')}, null, function (response) {
                        if (response.status === 'OK') {
                            self.modalNews = response.data;

                            self.$modal.show('lastNews');

                        }
                    });
                }
            },
            older: function() {
                this.pagination += newsPerPage;
                this.getNewsList();
            },
            newer: function() {
                if (this.pagination != 0) {
                    this.pagination -= newsPerPage;
                    this.getNewsList();
                }
            },
            closeNewNews: function() {
                let self = this;

                let session = self.$session.get('user');
                session.newNews = 0;

                self.$session.set('user', session);

                rm_katris.makePost('katrisSaleAdmin', 'setNewsRead', {'token': this.$session.get('jwt'), 'pagination': this.pagination}, null, function(response) {
                    console.log(response)
                });
            },
            checkRMStorage: function() {
                let self = this;

                if (self.$session.get('user').loginId == '4141') { //Работает только на "Изделия стандартные"!
                    rm_katris.makePost('katrisService', 'getStorageRMLimits', {'token': self.$session.get('jwt')}, null, function (respond) {
                        if (respond.status == "OK") {
                            self.toOrder = [];
                            for (let item in respond.data) {
                                if (parseInt(respond.data[item].count2) <= parseInt(respond.data[item].min) && respond.data[item].min != null && respond.data[item].max != null && respond.data[item].max > 0 && respond.data[item].max > respond.data[item].min) {
                                    respond.data[item].toOrder = respond.data[item].max - respond.data[item].count2;
                                    self.toOrder.push(respond.data[item])
                                }
                            }
                            self.$modal.show('toOrder');
                        }
                    });
                }
            },
            isMobile() {
                if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    return true
                } else {
                    return false
                }
            }
        },
    }
</script>

<style scoped>
    .news-header {
        line-height: 1;
        border-bottom: 1px solid #e5e5e5;
    }

    .display-4 {
        font-size: 2.5rem;
    }

    @media (min-width: 768px) {
        .display-4 {
            font-size: 3rem;
        }
    }

    .news-pagination {
        margin-bottom: 4rem;
    }

    .news-post {
        margin-bottom: 25px;
        padding-bottom: 25px;
        border-bottom: 1px solid #dee2e6
    }

    .news-post-title {
        margin-bottom: .25rem;
        font-size: 2.5rem;
    }

    .news-post-meta {
        margin-bottom: 1.25rem;
        color: #999;
    }

    .ql-video {
        width: 100%;
        height: 411px;
    }
</style>
